/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductListSkuMembershipOperation } from './ProductListSkuMembershipOperation';
// @ts-ignore
import {
// @ts-ignore
    ProductListSkuMembershipOperationFromJSON,
// @ts-ignore
    ProductListSkuMembershipOperationFromJSONTyped,
// @ts-ignore
    ProductListSkuMembershipOperationToJSON,
} from './ProductListSkuMembershipOperation';

/**
 * 
 * @export
 * @interface AddOrRemoveSkusToProductList
 */
export interface AddOrRemoveSkusToProductList {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOrRemoveSkusToProductList
     */
    skuIds: Array<string>;
    /**
     * 
     * @type {ProductListSkuMembershipOperation}
     * @memberof AddOrRemoveSkusToProductList
     */
    operation: ProductListSkuMembershipOperation;
}

/**
 * Check if a given object implements the AddOrRemoveSkusToProductList interface.
 */
// @ts-ignore
export function instanceOfAddOrRemoveSkusToProductList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "skuIds" in value;
    isInstance = isInstance && "operation" in value;

    return isInstance;
}

// @ts-ignore
export function AddOrRemoveSkusToProductListFromJSON(json: any): AddOrRemoveSkusToProductList {
    return AddOrRemoveSkusToProductListFromJSONTyped(json, false);
}

// @ts-ignore
export function AddOrRemoveSkusToProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrRemoveSkusToProductList {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'skuIds': json['sku_ids'],
        'operation': ProductListSkuMembershipOperationFromJSON(json['operation']),
    };
}

// @ts-ignore
export function AddOrRemoveSkusToProductListToJSON(value?: AddOrRemoveSkusToProductList | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sku_ids': value.skuIds,
        'operation': ProductListSkuMembershipOperationToJSON(value.operation),
    };
}

